import { useState } from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@grupoboticario/flora-react-icons';
import { ListComponents } from './components.styles';
import type { AccordionProps } from './components';

export const Accordion = ({ title, children }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  function handleSummaryClick() {
    return setIsOpen(!isOpen);
  }

  return (
    <ListComponents.Details>
      <ListComponents.Summary onClick={handleSummaryClick}>
        {title}
        <ListComponents.ArrowSpan>
          {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </ListComponents.ArrowSpan>
      </ListComponents.Summary>
      <ListComponents.Ul>{children}</ListComponents.Ul>
    </ListComponents.Details>
  );
};
